import gql from 'graphql-tag'

export const GET_PART_TYPES = gql`
  query PartTypes($filter: GetPartTypesFilter) {
    partTypes(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      partTypes {
        data {
          partTypeId
          companyId
          partCategoryId
          type
          partCategory {
            category
            partCategoryId
          }
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_PART_TYPE_BY_ID = gql`
  query PartType($filter: GetPartTypeFilter!) {
    partType(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      partType {
        partTypeId
        companyId
        partCategoryId
        type
        partCategory {
          category
          partCategoryId
        }
      }
    }
  }
`

export const CREATE_PART_TYPE = gql`
  mutation CreatePartType($input: CreatePartTypeInput!) {
    createPartType(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createPartType {
        partCategory {
          category
          partCategoryId
        }
        partCategoryId
        type
        partTypeId
        companyId
      }
    }
  }
`

export const UPDATE_PART_TYPE = gql`
  mutation UpdatePartType($input: UpdatePartTypeInput!) {
    updatePartType(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updatePartType {
        partCategory {
          category
          partCategoryId
        }
        partCategoryId
        partTypeId
        type
        companyId
      }
    }
  }
`

export const DELETE_PART_TYPE = gql`
  mutation DeletePartType($input: DeletePartTypeInput!) {
    deletePartType(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deletePartType {
        partCategory {
          category
          partCategoryId
        }
        partCategoryId
        partTypeId
        type
        companyId
      }
    }
  }
`
